import React from 'react';
import dayjs from 'dayjs';
import { Form } from 'antd';
import { formatNumberToCurrency } from 'pages/globals/global';
import { Box, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

const getOrdinalSuffix = (num) => {
	const j = num % 10;
	const k = num % 100;
	if (j === 1 && k !== 11) return num + 'st';
	if (j === 2 && k !== 12) return num + 'nd';
	if (j === 3 && k !== 13) return num + 'rd';
	return num + 'th';
};

// const formatAmount = (amount) => {
// 	const num = parseFloat(amount);
// 	if (isNaN(num)) return '';
// 	return new Intl.NumberFormat('en-US', {
// 		style: 'decimal',
// 		minimumFractionDigits: 2,
// 		maximumFractionDigits: 2,
// 	}).format(num);
// };

const GrossRentHistory = ({ data = [], index, otherChanges }) => {
	// console.log(data,'data123555');
	const form = Form.useFormInstance();
	const effectiveDateHistory = form.getFieldValue('effectiveDateHistory');

	return (
		<Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
			{/* Header Section (Title + Chips) */}
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: 1.5,
					flexWrap: 'wrap',
					mb: 1.5,
					justifyContent: 'space-between',
				}}
			>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
					<Box
						sx={{
							width: '24px',
							height: '24px',
							borderRadius: '50%',
							backgroundColor: index === 0 ? '#4caf50' : '#ff9800',
							color: 'white',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							fontSize: '12px',
							fontWeight: 'bold',
						}}
					>
						{index + 1}
					</Box>
					<Typography sx={{ fontSize: '14px', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
						{index === 0 ? 'Initial - on creation:' : `${getOrdinalSuffix(index)} Modification:`}
					</Typography>
				</Box>
				{/* Corrected: Removed the problematic 'width: 50vw' */}
				<Box
					sx={{
						display: 'flex',
						gap: '4px',
						flexWrap: 'wrap',
						alignItems: 'center',
						justifyContent: 'flex-end',
					}}
				>
					<Chip
						label={`Effective Date: ${dayjs(effectiveDateHistory?.[index]).format('DD-MM-YYYY')}`}
						variant="outlined"
						size="small"
						sx={{ fontSize: '11px', height: '24px', backgroundColor: '#f8f9fa' }}
					/>
					<Chip
						label={`IBR: ${otherChanges?.inputChangeDiscountRate}`}
						size="small"
						sx={{ fontSize: '11px', backgroundColor: '#e8f5e9' }}
					/>
					<Chip
						label={`Payment Frequency: ${otherChanges?.paymentFrequency}`}
						size="small"
						sx={{ fontSize: '11px', backgroundColor: '#fff3e0' }}
					/>
					<Chip
						label={`Payment Modality: ${otherChanges?.paymentTime?.toLowerCase() === 'start' ? 'Advance Basis' : 'Accrual Basis'}`}
						size="small"
						sx={{ fontSize: '11px', backgroundColor: '#e3f2fd' }}
					/>
				</Box>
			</Box>

			{/* Table section styling remains the same */}
			<TableContainer
				sx={{
					flexGrow: 1,
					'& table, & th, & td': {
						border: '1px solid #e0e0e0',
						borderCollapse: 'collapse',
					},
					'& th, & td': {
						padding: '8px 12px',
						fontSize: '13px',
					},
					'& th': {
						fontWeight: 'bold',
					},
					'& table': {
						width: '100%',
						tableLayout: 'fixed',
					},
				}}
			>
				<Table size="small" aria-label="Lease Payment Schedule">
					<TableHead
						sx={{
							'& .MuiTableCell-root': {
								textAlign: 'center',
							},
						}}
					>
						<TableRow>
							<TableCell sx={{ width: '20%' }}>From</TableCell>
							<TableCell sx={{ width: '20%' }}>To</TableCell>
							<TableCell sx={{ width: '30%' }}>Amount</TableCell>
							<TableCell sx={{ width: '30%' }}>Notes</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{data.length > 0 ? (
							data.map((row, rowIndex) => (
								<TableRow key={rowIndex}>
									<TableCell sx={{ textAlign: 'center' }}>{row.from}</TableCell>
									<TableCell sx={{ textAlign: 'center' }}>{row.to}</TableCell>
									<TableCell
										sx={{
											textAlign: 'right',
											fontFamily: 'monospace',
										}}
									>
										{formatNumberToCurrency(row.amount)}
									</TableCell>
									<TableCell>{row.remarks || ''}</TableCell>
								</TableRow>
							))
						) : (
							<TableRow>
								<TableCell colSpan={4} sx={{ textAlign: 'center', p: 3 }}>
									No data available
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	);
};

export default GrossRentHistory;
